import React from "react";
import { AlertTriangle } from "lucide-react";
import { formatEUR } from "@/lib/utils";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const eur = (x) => (x == null ? "non determinabile" : formatEUR(x));

// Sprint 9 — confronto prima/dopo calcolato dal server (nessun calcolo qui)
export function ConfrontoRegime({ a, testid }) {
  const righe = [["Regime", a.prima.regime, a.dopo.regime], ["Imponibile", eur(a.prima.imponibile), eur(a.dopo.imponibile)],
    ["Imposta", eur(a.prima.imposta), eur(a.dopo.imposta)], ["Margine", eur(a.prima.margine), eur(a.dopo.margine)]];
  return (
    <div data-testid={testid}>
      <table className="w-full text-xs">
        <thead><tr className="text-slate-500"><th className="text-left font-medium"></th><th className="text-left font-medium">Prima</th><th className="text-left font-medium">Dopo</th></tr></thead>
        <tbody>{righe.map(([l, p, d]) => (
          <tr key={l} className="border-t"><td className="py-1 pr-2 text-slate-600">{l}</td><td className="py-1 pr-2">{p}</td><td className="py-1 font-medium">{d}</td></tr>
        ))}</tbody>
      </table>
      <AvvisiRecord a={a} />
    </div>
  );
}

function AvvisiRecord({ a }) {
  const docs = a.documenti_archiviati || [];
  return (
    <>
      {a.status === "venduta" && (
        <p className="mt-1 text-[11px] text-amber-800" data-testid={`riall-venduta-${a.vendita_id}`}>
          Pratica venduta: il contratto già emesso riporta il regime precedente. Valuta se rigenerarlo in una nuova versione.
        </p>
      )}
      {docs.length > 0 && (
        <p className="mt-1 text-[11px] text-amber-800" data-testid={`riall-docs-${a.vendita_id}`}>
          Esistono {docs.length} documenti archiviati emessi con il regime precedente: restano invariati. Rigenerali se serve.
        </p>
      )}
    </>
  );
}

export function RiallineamentoCaricoDialog({ esito, onClose }) {
  if (!esito) return null;
  const rial = esito.riallineati || [];
  const non = esito.non_riallineati || [];
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="riallineamento-dialog">
        <DialogHeader><DialogTitle>Regime IVA riallineato al nuovo carico</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-700" data-testid="riallineamento-conteggio">
          Riallineati {esito.preventivi} preventivi e {esito.pratiche} pratiche. Cambiando il regime cambiano lo scorporo
          IVA (imponibile e imposta); il margine è riportato per confronto.
        </p>
        <div className="space-y-3">
          {rial.map((a) => (
            <div key={a.vendita_id} className="border rounded-md p-2">
              <div className="text-xs font-semibold mb-1">{a.tipo === "preventivo" ? "Preventivo" : "Pratica"} {a.codice}</div>
              <ConfrontoRegime a={a} testid={`riallineato-${a.vendita_id}`} />
            </div>
          ))}
          {non.map((a) => (
            <div key={a.vendita_id} className="border border-rose-300 bg-rose-50 rounded-md p-2 text-xs text-rose-900" data-testid={`non-riallineato-${a.vendita_id}`}>
              <div className="flex items-center gap-1 font-semibold"><AlertTriangle className="h-3.5 w-3.5" /> Non riallineata: {a.tipo === "preventivo" ? "preventivo" : "pratica"} {a.codice}</div>
              <div>{a.motivo}</div>
            </div>
          ))}
        </div>
        <DialogFooter><Button onClick={onClose} data-testid="riallineamento-ok">Ho capito</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
